import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { designSystem, reactHookForm } from '@yola/ws-ui';

const { Box, TextAreaField, FieldStatus } = designSystem;
const { useController } = reactHookForm;
const defaultRules = {};

const TextField = ({
  name,
  placeholder,
  statusText = '',
  isSubField = false,
  control,
  rules = defaultRules,
  maxLength,
}) => {
  const classes = classNames('ws-difm-order-form-textarea', {
    'ws-difm-order-form-textarea--sub-field': isSubField,
  });
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });
  const lengthInfo = `${field.value.length}/${maxLength}`;

  const { invalid, error } = fieldState;
  const fieldStatusText = invalid ? error?.message : statusText;
  const fieldStatusAppearance = invalid ? 'error' : 'default';
  const elementAfter = (
    <div className="ws-difm-order-form-textarea__info">
      <FieldStatus text={fieldStatusText || ''} appearance={fieldStatusAppearance} />
      <FieldStatus text={lengthInfo} appearance={fieldStatusAppearance} align="right" />
    </div>
  );

  return (
    <Box {...(isSubField && { paddingLeft: 'spacing-l' })}>
      <div className={classes}>
        <TextAreaField
          resize
          control={control}
          rules={rules}
          name={name}
          placeholder={placeholder}
          elementAfter={elementAfter}
        />
      </div>
    </Box>
  );
};

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  statusText: PropTypes.string,
  isSubField: PropTypes.bool,
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
  maxLength: PropTypes.number.isRequired,
};

export default TextField;
